import { render, staticRenderFns } from "./CustomSzwtIotStatsForm.vue?vue&type=template&id=13648d3c&"
import script from "./CustomSzwtIotStatsForm.vue?vue&type=script&lang=js&"
export * from "./CustomSzwtIotStatsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports